/*global MYEVENTS_ELECTRON */
let esUtils = require("ES/utils/esUtils");

if(typeof MYEVENTS_ELECTRON === "undefined"){
	module.exports = {
		is_on: false
	};
}else{
	module.exports = {
		is_on: true,
		logout_url: (function(){
			var url = "/balboa3/authenticate/destroysession";
			url += "?" + esUtils.phpCompatibleParams({
				redir: "/myevents/signin"
			});
			return url;
		}()),
		quit: MYEVENTS_ELECTRON.quit
	};
}



// WEBPACK FOOTER //
// ./src/utils/Electron.js